import { generatePath } from "react-router-dom";

import { TaskStatus } from "@/constants";
import { SearchFilter, SearchFilterV4 } from "@/types/SearchFilter";

import fetcher_v2 from "../fetcher_v2";
import { URLS } from "../urls";

type TaskBody = {
  start_date: string;
  end_date: string;
  insights_report_uuid?: string | null;
  filters: SearchFilter | SearchFilterV4;
  language: string;
  currency: string;
};

export const newTask = <T extends string>(type: T, body: TaskBody) => {
  return fetcher_v2<{ task_id: string; task_type: T }, TaskBody>(
    generatePath(URLS.TASK_NEW, { type }),
    {
      method: "POST",
      body,
    }
  );
};

type TaskStatusResponse<T = unknown[]> = {
  task_status: TaskStatus;
  data: T;
};

export const getTaskStatus = <T>(type: string, id: string) => {
  return fetcher_v2<TaskStatusResponse<T>>(
    generatePath(URLS.TASK_STATUS, { type, id })
  );
};

export const getAnalyticsWidgetData = (
  url: string,
  metric: string,
  search_id: string,
  filters: SearchFilter,
  signal?: AbortSignal
) => {
  return fetcher_v2<{ search_id: string }>(
    generatePath(url, { metric, search_id }),
    {
      method: "GET",
      body: filters,
      signal,
    }
  );
};

export const getReportWidgetData = (
  url: string,
  metric: string,
  widget_id: string,
  filters: SearchFilter,
  signal?: AbortSignal
) => {
  return fetcher_v2<{ search_id: string }>(
    generatePath(url, { metric, widget_id }),
    {
      method: "GET",
      body: filters,
      signal,
    }
  );
};
